export const SMART_QUERY_DETECTED_FLAG_ID = 'SMART_QUERY_DETECTED_FLAG_ID';
